import { FormattedMessage, useIntl } from 'react-intl'
import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Contest_SiteEventListWrapper} from './contest_site-event/Contest_SiteEventList'

const parametersBreadcrumbs: Array<PageLink> = [
  {
    title: <FormattedMessage id ="CONTESTS_SITE.EVENT"/>,
    path: 'contestsite-event',
    isSeparator: true,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Contest_SiteEventPage = () => {
  const intl = useIntl()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='cse'
          element={
            <>
              <PageTitle breadcrumbs={parametersBreadcrumbs}>{intl.formatMessage({ id: 'CONTESTS_SITE.EVENTS.LIST' })}</PageTitle>
              <Contest_SiteEventListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/contestsite-event/cse' />} />
    </Routes>
  )
}

export default Contest_SiteEventPage
